// extracted by mini-css-extract-plugin
export default {"title":"eDTwZJc_JLC1415tHCt_","info":"MIWwdMXtU0TwqtcwdZfB","actionButton":"mf1zV7gtoO2q0MNWmNSt","switcherButton":"bwRp3Z0ro8mItJL1WIrm"};